import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { login } from "../../redux/authSlice";
import { loginUser } from "../../services/authService";

function Login() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const [credentials, setCredentials] = useState({ email: "admin", password: "123" });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/dashboard");
  }, [user, navigate]);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const { email, password } = credentials;

    if (!email.trim() || !password.trim()) {
      setError("Por favor, ingrese su email y contraseña.");
      return;
    }

    try {
      const data = await loginUser(email, password);
      dispatch(login({ user: data.user, token: data.token, empresas: data.empresas }));
      navigate("/dashboard");
    } catch (error) {
      setError(error.mensaje);
    }
  };

  return (
    <div className="login login-v2 fw-bold">
      <div className="login-cover">
        <div
          className="login-cover-img"
          style={{
            backgroundImage: `url(/assets/img/login-bg/login-bg-17.jpg)`,
          }}
        ></div>
        <div className="login-cover-bg"></div>
      </div>

      <div className="login-container">
        <div className="login-header">
          <div className="brand">
            <div className="d-flex align-items-center">
              <span className="logo"></span> <b>Mambo</b> Admin
            </div>
            <small>Sistema de control de facturacion</small>
          </div>
          <div className="icon">
            <i className="fa fa-lock"></i>
          </div>
        </div>

        <div className="login-content">
          <form onSubmit={handleLogin}>
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="form-floating mb-20px">
              <input
                type="text"
                name="email"
                className="form-control fs-13px h-45px border-0"
                placeholder="Email Address"
                value={credentials.email}
                onChange={handleChange}
              />
              <label className="d-flex align-items-center text-gray-600 fs-13px">Email</label>
            </div>
            <div className="form-floating mb-20px">
              <input
                type="password"
                className="form-control fs-13px h-45px border-0"
                placeholder="Password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
              />
              <label className="d-flex align-items-center text-gray-600 fs-13px">Contraseña</label>
            </div>
            <div className="form-check mb-20px">
              <input className="form-check-input border-0" type="checkbox" id="rememberMe" />
              <label className="form-check-label fs-13px text-gray-500" htmlFor="rememberMe">
                Mantener sesion abierta
              </label>
            </div>
            <div className="mb-20px">
              <button type="submit" className="btn btn-theme d-block w-100 h-45px btn-lg">
                Entrar
              </button>
            </div>
            {/* <div className="text-gray-500">
              Aun no eres miembro? Click <Link to="/register">aqui</Link> para registrarte.
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
